import React, { Component } from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import AlphaListing from './AlphaListing';
import Category from './Category';
import Description from './Description';
import Screen from './Screen';
import Video from './Video';
import './styles.css';

class Service1203 extends Component {
  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="service-1203">
        <Switch>
          <Route path="/movies/video/:categoryName/:movieName?" component={Video} />
          <Route path="/movies/screen/:categoryName/:movieName?" component={Screen} />
          <Route path="/movies/categories/:categoryName/:movieName/:backPath?" component={Description} />
          <Route path="/movies/categories/:categoryName" component={Category} />
          <Route path="/movies/listing/:categoryName/:movieName?" component={AlphaListing} />
          <Route path="/movies" render={() => <Redirect to="/movies/categories/action" />} />
        </Switch>
      </div>
    );
  }
}

export default withRouter(Service1203);
